































import { CarouselBreakpoint } from '@/app_code/CarouselBreakpoint';
import { TestimonialFilter } from 'client-website-ts-library/filters';
import { API } from 'client-website-ts-library/services';
import { Testimonial } from 'client-website-ts-library/types';
import { Component, Vue } from 'vue-property-decorator';
import RichText from './Common/RichText.vue';
import Cycler from './Cycler/Cycler.vue';
import CyclerItem from './Cycler/CyclerItem.vue';

@Component({
  components: {
    Cycler,
    CyclerItem,
    RichText,
  },
})
export default class TestimonialCarousel extends Vue {
  testimonials: Testimonial[] | null = null;

  private cyclerBreakpoints: CarouselBreakpoint[] = [
    {
      breakpoint: 0,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
      },
    },
  ];

  mounted() {
    API.Testimonials.Search(new TestimonialFilter()).then((testimonials) => {
      this.testimonials = testimonials.filter((t) => t.Address && t.ClientName);
    });
  }
}
